angular.module('callX').service('LeadsService', ['$http', '$rootScope', 'UserService',
  function ($http){

    var getLeadUsersList = function(pageno,size,id, callbacks){
      $http.get("/japi/allleads/"+id+"/?page="+pageno+"&"+"size="+size)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getPromoGranularDataExportCSV = function(pageno,size,id, callbacks){
      $http.get("/japi/allleads-download/"+id+"/?page="+pageno+"&"+"size="+size)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getLeadUsersListData = function(pageno,size,id, callbacks){
      $http.get("/japi/allleads/"+id+"/?page="+pageno+"&"+"size="+size)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getSingleLeadUserDetails = function(id, callbacks){
      $http.get("/japi/leaddata/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getAllFieldsListForLeads = function(callbacks){
          $http.get("/japi/allleadfields")
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var getLeadHistory = function(id, callbacks){
          $http.get("/japi/leadhistory/"+id)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

    return {
      getLeadUsersList: function (pageno,size,id, callbacks) {
        getLeadUsersList(pageno,size,id, callbacks);
      },
      getPromoGranularDataExportCSV: function (pageno,size,id, callbacks) {
        getPromoGranularDataExportCSV(pageno,size,id, callbacks);
      },
      getLeadUsersListData: function (pageno,size,id, callbacks) {
        getLeadUsersListData(pageno,size,id, callbacks);
      },
      getSingleLeadUserDetails: function (id, callbacks) {
        getSingleLeadUserDetails(id, callbacks);
      },
      getAllFieldsListForLeads: function (callbacks) {
            getAllFieldsListForLeads(callbacks);
      },
      getLeadHistory: function (id, callbacks) {
            getLeadHistory(id, callbacks);
      }   
    };
  }]);